// extracted by mini-css-extract-plugin
export var option = "_4x-1";
export var optionActive = "_4x-2";
export var pill = "_4x-0";